import { Tool } from '../../data/tools';

export const metadata: Tool = {
  id: 'random-recipe',
  name: 'Random Recipe Generator',
  description: 'Generate instant cooking recipes with step-by-step instructions, ingredients, and video guides.',
  category: 'Explore',
  icon: 'ChefHat',
  route: '/tools/random-recipe',
  metaTitle: 'Random Recipe Generator — Cooking Inspiration & Recipes Online',
  metaDescription: 'Find daily cooking inspiration instantly with our free online random recipe board. Get full ingredient lists, measures, guides, and YouTube tutorials.',
  keywords: [
    'random recipe generator',
    'what should i cook today',
    'random recipe board',
    'recipe finder online',
    'dinner ideas generator',
    'cooking recipes developer API',
    'random meals helper'
  ],
  longDescription: 'The Random Recipe Generator provides instant cooking inspiration by pulling random recipes from global culinary databases. Each card details the recipe name, category/origin tags, exact ingredient measurement ratios, preparation steps, and embedded video tutorials.',
  howToUse: [
    'Click the "Generate Recipe" button to load a random recipe.',
    'Check off ingredients as you gather them in your kitchen using the list checkboxes.',
    'Follow the step-by-step instructions under the "Cooking Guide" tab.',
    'Watch the video tutorial or visit the original recipe source link for extra tips.'
  ],
  benefits: [
    'Fetches live meal lists from public food databases.',
    'Includes step-by-step prep details, portion guides, and measurements.',
    'Runs fully client-side on mobile and desktop without cookies.'
  ],
  faq: [
    {
      question: 'What types of cuisines are available?',
      answer: 'The generator accesses a global food database covering various cuisines including Italian, French, American, Chinese, Indian, Mexican, British, and others.'
    },
    {
      question: 'Are there options for dietary restrictions?',
      answer: 'This is a random recipe generator intended for quick cooking inspiration. While you cannot filter by dietary restrictions in this lightweight version, each recipe clearly categorizes its tags (e.g. Vegetarian, Seafood, Chicken).'
    },
    {
      question: 'How do I save a recipe I like?',
      answer: 'You can copy the recipe name or bookmark the source link provided under the instructions tab to reference it later.'
    }
  ]
};
